export default {
  methods: {

    draw_Forms() {

      this.canvasSVG = this.svg
      .append('g')
      .attr('transform', `translate(.5, .5)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')


      // sundriesConfig: {SQL: '', server: 'KASKIDA'},
      // sundries: [
      // ],

      // this.sundries  = json.sundries
      // {type: 'image', x: 0, y: 0, width: 30, server: 'trion-dev', url: 'icon/svg/', file: 'naver', ext: 'png',},
      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },
  }
}